import { compareValues } from "@sscs/utils";
import { intersection } from "lodash";
export const ID_DESCRIPTION_DELIMITER = " - ";
/** Transforms prevalence to use only component community and merges
 * transparency information with behaviors
 * */
export const transformBehaviorsForDisplay = (behavior, component) => {
    var _a;
    const result = [];
    behavior.forEach((item) => {
        var _a;
        result.push({
            ...item,
            prevalence: (component === null || component === void 0 ? void 0 : component.identity.community) &&
                item.prevalence[component.identity.community]
                ? {
                    [component.identity.community]: item.prevalence[component.identity.community],
                }
                : {},
            id: item.identifier,
            trigger_entry: (_a = component === null || component === void 0 ? void 0 : component.transparency) === null || _a === void 0 ? void 0 : _a.via_policy[item.identifier],
        });
    });
    (_a = component === null || component === void 0 ? void 0 : component.transparency) === null || _a === void 0 ? void 0 : _a.non_policy.forEach(([description, trigger], index) => {
        result.push({
            description: description,
            prevalence: {},
            repository_statistics: {},
            maliciousness: null,
            total: null,
            trigger_entry: trigger,
            id: index.toString(),
        });
    });
    return result;
};
export const convertRelevance = (relevance) => {
    switch (relevance) {
        case "high":
            return "Relevant";
        case "low":
            return "Contributing";
        default:
            return "--";
    }
};
export const initFilter = {
    category: "ALL",
    idAndDescription: "",
    prevalence: [],
    showMlDetected: false,
};
export const initSort = {
    property: "category",
    reverse: false,
};
export const filterBehaviors = (behavior, filter) => {
    const hasCategoryFilter = filter.category !== initFilter.category;
    const hasDescriptionFilter = filter.idAndDescription !== initFilter.idAndDescription;
    const hasPrevalenceFilter = filter.prevalence.length > 0;
    if (!hasCategoryFilter &&
        !hasDescriptionFilter &&
        !hasPrevalenceFilter &&
        !filter.showMlDetected) {
        return behavior;
    }
    return behavior.filter((item) => {
        var _a, _b;
        if (hasCategoryFilter &&
            ((_a = item.category) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== filter.category.toLowerCase()) {
            return false;
        }
        if (hasDescriptionFilter) {
            const itemIdAndDescription = `${item.identifier}${ID_DESCRIPTION_DELIMITER}${item.description}`;
            if (!itemIdAndDescription
                .toLowerCase()
                .includes(filter.idAndDescription.toLowerCase()))
                return false;
        }
        if (hasPrevalenceFilter) {
            const behaviorPrevalence = Object.keys(item.prevalence).length > 0;
            if (behaviorPrevalence) {
                const uniqueIndicatorPrevalence = new Set();
                Object.values(item.prevalence).forEach((communityPrevalence) => {
                    communityPrevalence.forEach((item) => uniqueIndicatorPrevalence.add(item));
                });
                if (intersection(Array.from(uniqueIndicatorPrevalence), filter.prevalence)
                    .length === 0) {
                    return false;
                }
            }
            else {
                if (!filter.prevalence.includes("unknown")) {
                    return false;
                }
            }
        }
        if (filter.showMlDetected &&
            (!((_b = item.trigger_entry) === null || _b === void 0 ? void 0 : _b.relevance) ||
                item.trigger_entry.relevance === "none")) {
            return false;
        }
        return true;
    });
};
export const behaviorSortSpecialCases = {
    relevance: (first, second, reverse) => {
        var _a, _b;
        return compareValues(convertRelevance((_a = first.trigger_entry) === null || _a === void 0 ? void 0 : _a.relevance), convertRelevance((_b = second.trigger_entry) === null || _b === void 0 ? void 0 : _b.relevance), reverse);
    },
};
//# sourceMappingURL=utils.js.map